/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import copyLinkIcon from "dc-icons/viewer2021/SDC_CopyLink_18_N.svg";
import { contextMenuPlacements } from "constants/enums";
import { modernViewerDropinContext, VERB_COPY_LINK } from "../constants/enums";
import { getCoordinatesRelativeToPage } from "utils/EventHandlingUtils";
import { copyTextToClipboard } from "utils/CopyTextUtils";
import * as stores from "stores";
import { getHyperlinkUrl } from "../utils/UrlUtils";

class CopyHyperlinkBootstrap extends Component {
  getLabel = () => getMessage("contextMenu.modernViewer.copyLink");

  getIcon = () => copyLinkIcon;

  getTooltip = () => getMessage("contextMenu.modernViewer.copyLink");

  getAriaLabel = () => getMessage("contextMenu.modernViewer.copyLink");

  getPlacement = () => contextMenuPlacements.CONTEXT_MENU_BODY;

  id = VERB_COPY_LINK;

  initializeAction = (opts = {}) => {
    const event = opts.triggerEventObj;
    const pageIndex = opts.pageIndex;
    const { x, y } = getCoordinatesRelativeToPage(event);
    getHyperlinkUrl(x, y, pageIndex)
      .then(url => {
        this.hyperlinkUrl = url;
      })
      .catch(() => {
        this.hyperlinkUrl = undefined;
      });
  };

  executeAction = (opts = {}) => {
    if (opts.context && opts.context === modernViewerDropinContext.CONTEXT_MENU) {
      if (this.hyperlinkUrl) {
        copyTextToClipboard(this.hyperlinkUrl, stores);
      }
    }
  };

  render() {
    return null;
  }
}

export default CopyHyperlinkBootstrap;
